module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[105]470.9a532ae.woff2";